import React, { FC } from 'react';
import { Text } from '@morressier/ts';

import { useTimeToNow } from 'hooks/useTimeNow';
import { BlackVideoCard, SimpleCard } from 'containers/SessionsList/styles';
import { useSessionTime } from './hooks';

export const StandBy: React.FC<ReturnType<typeof useSessionTime>> = ({ isHappeningNow }) => (
  <SimpleCard color="#1F222C" cursor="unset" style={{ height: '100%' }}>
    <Text color="white" fontWeight="semiBold" style={{ maxWidth: 360, margin: 'auto' }}>
      {isHappeningNow
        ? 'Session is starting soon...'
        : 'Session ended without starting live stream'}
    </Text>
  </SimpleCard>
);

export const CountDown: FC<{ session: MorressierSession }> = ({ session }) => {
  const { timeToNow } = useTimeToNow(session.start_date);
  const sessionTime = useSessionTime({
    startDate: session.start_date,
    endDate: session.end_date,
    options: { runPastDates: true },
  });

  if (sessionTime.isPreSession) {
    return (
      <BlackVideoCard>
        <div className="mb1">
          <Text size="h4_new" color="white" fontWeight="bold">
            Session starting in {timeToNow}
          </Text>
        </div>
      </BlackVideoCard>
    );
  }

  return <StandBy {...sessionTime} />;
};
